import React, { createContext, useContext, useState, useEffect } from 'react';

export const THEMES = {
  blue: {
    key:     'blue',
    name:    'Sky Blue',
    primary: '#C6DEF1',
    accent:  '#E0E2FB',
    label:   'Cool & Professional',
  },
  teal: {
    key:     'teal',
    name:    'Teal Mint',
    primary: '#C9E4DE',
    accent:  '#C6DEF2',
    label:   'Fresh & Natural',
  },
  peach: {
    key:     'peach',
    name:    'Warm Peach',
    primary: '#F1DBCD',
    accent:  '#FAF2D0',
    label:   'Warm & Welcoming',
  },
};

const STORAGE_KEY = 'kulish-theme';
const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [theme, setThemeState] = useState(
    () => localStorage.getItem(STORAGE_KEY) || 'blue'
  );

  // Apply data-theme attribute to <html> whenever theme changes
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem(STORAGE_KEY, theme);
  }, [theme]);

  // Also set the initial theme on mount (handles page refresh)
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, []); // eslint-disable-line

  const setTheme = (key) => {
    if (THEMES[key]) setThemeState(key);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, themes: THEMES, current: THEMES[theme] }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside <ThemeProvider>');
  return ctx;
}
